export const type = "flagCategory";

const flagCategory = () => {
  return {
    type,
  };
};

export default flagCategory;
